import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker/es';
import FormError from '../_shared/forms/FormError';
import SubmitButton from '../_shared/SubmitButton';
import { snakeCaseToTitle } from '../../utils/Helpers';
import axios from 'axios';

export default class WasteJobRemovalsReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date_from: '',
            date_to: '',
            loading: false,
            notFound: false,
            errors: {},
        };
    }

    handleDateChange = (date, property) => {
        this.setState({ [property]: date });
    };

    validateForm = () => {
        let errors = {};
        ['date_from', 'date_to'].forEach((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors });

        if (Object.keys(errors).length > 0) toastr.error('Please fill in all required fields');

        return Object.keys(errors).length === 0;
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ notFound: false });

        if (!this.validateForm()) return;

        this.setState({ loading: true });

        const date_from = moment(this.state.date_from).format('YYYY-MM-DD');
        const date_to = moment(this.state.date_to).format('YYYY-MM-DD');
        const file_name = `waste-job-removals-${date_from}-to-${date_to}.xlsx`;

        axios({
            url: this.props.url,
            method: 'GET',
            responseType: 'blob',
            params: { date_from, date_to },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file_name);
                document.body.appendChild(link);
                link.click();

                this.setState({ loading: false });
            })
            .catch(() => {
                this.setState({ notFound: true, loading: false });
            });
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">Filter Waste Job Removals</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <DatePicker
                            className="form-control"
                            placeholderText="Date from..."
                            selected={this.state.date_from}
                            onChange={(date) => this.handleDateChange(date, 'date_from')}
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                        <FormError error={this.state.errors.date_from} />
                    </div>
                    <div className="col-md-4 form-group">
                        <DatePicker
                            className="form-control"
                            placeholderText="Date to..."
                            selected={this.state.date_to}
                            onChange={(date) => this.handleDateChange(date, 'date_to')}
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                        <FormError error={this.state.errors.date_to} />
                    </div>
                    <div className="col-md-4 form-group">
                        <SubmitButton
                            buttonText="Download"
                            loading={this.state.loading}
                            style={{ width: 200 }}
                        />
                    </div>
                </div>

                {this.state.notFound && (
                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-danger text-center">No waste job removals found</p>
                        </div>
                    </div>
                )}
            </form>
        );
    }
}

// Mount
if (document.getElementById('waste-job-removals-report')) {
    const el = document.getElementById('waste-job-removals-report');

    ReactDOM.render(<WasteJobRemovalsReport url={el.dataset.url} />, el);
}
